export var AttachmentErrors;
(function (AttachmentErrors) {
    AttachmentErrors["InvalidFormat"] = "INVALID_FORMAT";
    AttachmentErrors["UploadFailed"] = "UPLOAD_FAILED";
    AttachmentErrors["GetPdfFailed"] = "GET_PDF_FAILED";
    AttachmentErrors["NoFileFound"] = "NO_FILE_FOUND";
    AttachmentErrors["NoFileProvided"] = "NO_FILE_PROVIDED";
})(AttachmentErrors || (AttachmentErrors = {}));
